import axios from 'axios';
import initMiniCart from '../global/mini-cart';
export const get = (triggerEvent) => {
    return axios.get('/cart.js').then((res) => {
        return res;
    });
};
export const getOrphanedItems = (cartItems) => {
    // Check if all remaining items are bundle children
    return cartItems.filter((item) => {
        // remove if it has no _time
        if (!item.properties._time)
            return false;
        // remove if it's a 'Base' item
        if (item.properties._element === 'Base')
            return false;
        // Keep if a matching Base item exists with same _time
        if (cartItems.some((other) => other.properties._element === 'Base' && other.properties._time === item.properties._time)) {
            return false;
        }
        return true;
    });
};
// CartDest determines if it is triggered by quick cart or main cart
export const refreshCart = (context, cartCount, cart) => {
    if (context == 'quick-cart') {
        const quickCart = document.querySelector('.quick-cart');
        // @ts-ignore
        var quickcartURL = ''.concat(window.theme.routes.cart.base, '?section_id=quick-cart');
        axios.get(quickcartURL).then((response) => {
            var container = document.createElement('div');
            container.innerHTML = response.data;
            // Update items
            const updatedItems = container.querySelector('.quick-cart__items');
            const currentItems = document.querySelector('.quick-cart__items');
            if (currentItems && updatedItems) {
                // Open the quick cart
                const cartWrapper = quickCart.querySelector('.quick-cart__wrapper');
                cartWrapper.classList.add('active');
                // Update the items
                currentItems.innerHTML = updatedItems.innerHTML;
                // Update footer
                const updatedFooter = container.querySelector('.quick-cart__footer');
                const currentFooter = document.querySelector('.quick-cart__footer');
                currentFooter.innerHTML = updatedFooter.innerHTML;
                // Update header
                const updatedHeader = container.querySelector('.quick-cart__header');
                const currentHeader = document.querySelector('.quick-cart__header');
                currentHeader.innerHTML = updatedHeader.innerHTML;
            }
            else {
                // Update the entire cart
                const currentContainer = document.querySelector('.quick-cart__container');
                const updatedContainer = container.querySelector('.quick-cart__container');
                currentContainer.innerHTML = updatedContainer.innerHTML;
                // Open the quick cart
                const cartWrapper = quickCart.querySelector('.quick-cart__wrapper');
                cartWrapper.classList.add('active');
                initMiniCart();
            }
            // Update the cart count
            var cartCountURL = ''.concat(window.Shopify.routes.root, '?section_id=cardigang-cart-count');
            axios.get(cartCountURL).then((response) => {
                var container = document.createElement('div');
                container.innerHTML = response.data;
                const updatedCount = container.querySelector('[data-cardigang-cart-count]');
                const currentCount = document.querySelector('[data-cardigang-cart-count]');
                currentCount.innerHTML = updatedCount.innerHTML;
                const innerBubble = currentCount.querySelector('.header__cart-link-count');
                if (innerBubble) {
                    innerBubble.innerHTML = cartCount;
                }
                else if (cartCount > 0) {
                    currentCount.innerHTML = `<span class="header__cart-link-count">${cartCount}</span>`;
                }
            });
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
                window.dispatchEvent(new CustomEvent('quick-cart:updated', { detail: { cart: cart } }));
            }, 200);
        });
    }
    else {
        // @ts-ignore
        window.location.reload();
    }
};
export const add = (items) => {
    if (items.length === 0) {
        return;
    }
    return axios
        .post('/cart/add.js', {
        items,
    })
        .then((res) => {
        return get();
    })
        .then((cart) => {
        const cartCount = getCartCount(cart.data.items);
        return refreshCart('quick-cart', cartCount, cart);
    });
};
const getCartCount = (cartItems) => {
    let cartCount = 0;
    cartItems.forEach((cartItem) => {
        if (cartItem.properties['_kit']) {
            if (cartItem.properties['_element'] == 'Base') {
                cartCount = cartCount + cartItem.quantity;
            }
        }
        else {
            cartCount = cartCount + cartItem.quantity;
        }
    });
    return cartCount;
};
export const update = (updates) => {
    if (Object.keys(updates).length === 0) {
        return;
    }
    return axios
        .post(window.Shopify.routes.root + 'cart/update.js', {
        updates: updates,
    })
        .then((res) => {
        return processResponse();
    });
};
export const change = (item) => {
    return axios.post('/cart/change.js', item).then((res) => {
        return processResponse();
    });
};
export const deleteItems = (deletes) => {
    if (Object.keys(deletes).length === 0) {
        return;
    }
    const updates = {};
    deletes.forEach((id) => {
        updates[id] = 0;
    });
    return update(updates);
};
export const empty = () => {
    return axios.post('/cart/clear.js').then((res) => {
        return window.location.reload();
    });
};
const processResponse = () => {
    // window.location.reload();
};
export const removeBundle = (productsToRemove, context) => {
    const itemsToRemove = {};
    productsToRemove.filter((part) => part != '').forEach((itemToRemove) => (itemsToRemove[itemToRemove] = 0));
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates: Object.assign({}, itemsToRemove) }),
    })
        .then((res) => {
        return get();
    })
        .then((cart) => {
        const cartCount = getCartCount(cart.data.items);
        return refreshCart(context, cartCount, cart);
    })
        .catch((error) => {
        console.error('Error:', error);
    });
};
export default {
    get,
    add,
    update,
    change,
    delete: deleteItems,
    empty,
    refreshCart,
    removeBundle,
    getOrphanedItems,
};
